import developmentConfig from "./development.config";
import productionConfig from "./production.config";
import versionMatrix from "./versionMatrix";

export interface Config {
  apiURL: string;
  wsUrl: string;
  awsExports: any;
  gaKey: string;
  hjid: number;
  hjsv: number;
}

const vercelEnv = process.env.REACT_APP_VERCEL_ENV;
const nodeEnv = process.env.NODE_ENV ?? "development";
const overrideEnv = process.env.REACT_APP_OVERRIDE_ENV;

export const appVersion = process.env.REACT_APP_VERSION;
export const requiredApiVersion = versionMatrix[appVersion ?? ""] as string | undefined;

export const env = overrideEnv ?? vercelEnv ?? nodeEnv;
export const isDev = env !== "production";
export const isProd = env === "production";
export const isPreview = env === "preview";

const config: Record<string, Config> = {
  test: developmentConfig,
  development: developmentConfig,
  preview: developmentConfig,
  production: productionConfig,
};

export default config[env];
